import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corso-modulo-main',
  templateUrl: './corso-modulo-main.component.html',
  styleUrls: ['./corso-modulo-main.component.css']
})
export class CorsoModuloMainComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
